/**
 * Uppercases only the value's first character, leaving everything else —
 * including the rest of the string's casing — untouched. `toLocaleUpperCase`
 * rather than `toUpperCase` so locale-specific casing rules apply; it's also
 * a safe no-op on scripts with no case distinction (Hebrew, Arabic, CJK).
 */
export function capitalizeFirstLetter(value: string): string {
  if (!value) return value
  const first = value[0]
  const upper = first.toLocaleUpperCase()
  // The near-universal steady state, once the first keystroke has already
  // capitalized a field: skip the allocation (`slice` + concat) rather than
  // rebuild an identical string on every later keystroke, however long the
  // field's content has grown.
  return first === upper ? value : upper + value.slice(1)
}
